<template>
    <div class="clearfix inviteFriendsGridItem">
        <div>
            <div class="desciconLarge"></div>
            <span class="font18">{{ title }}</span>
        </div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'aboutUsTitleLine',
    components: {},
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style scoped lang="scss">
.inviteFriendsGridItem {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
